import Vue from 'vue'
import App from './App.vue'
import router from './router'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap-icons/font/bootstrap-icons.css'
import store from './store'

// 添加全局提示组件
Vue.prototype.$toast = {
  success: (msg) => alert(`✅ ${msg}`),
  info: (msg) => alert(`ℹ️ ${msg}`),
  error: (msg) => alert(`❌ ${msg}`)
}

Vue.config.productionTip = false

new Vue({
  router,
  store, // 注入全局store
  render: h => h(App)
}).$mount('#app')
import 'bootstrap/dist/js/bootstrap.bundle.min.js'
